routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.tunnel', {
      url: __env.routes.tunnel,
      template: `<tunnel sh-ctrl="shCtrl"></tunnel>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/tunnel/tunnel.config.js
 **/